import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push
} from 'react-router-redux';
import {
  Button,
  Container,
  Header,
  Icon,
  List,
  Menu,
  Modal,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import ATable from '../../auto/ATable';

const PAGE_RANGE = 10;

class NominaCooperatviasView extends Component {

  constructor (props) {
    super(props);

    this.CooperativaService = this.props.feathers.service('/api/cooperativas');
    this.LocalidadService = this.props.feathers.service('/api/localidades');
    this.SectorService = this.props.feathers.service('/api/sectores');
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let localidadSelectConfig = {
      service: this.LocalidadService,
      mapFunction: (localidad, index) => {
        return {
          key: index,
          text: localidad.nombre,
          value: localidad.id
        };
      }
    };

    let sectorSelectConfig = {
      service: this.SectorService,
      mapFunction: (sector, index) => {
        return {
          key: index,
          text: sector.nombre,
          value: sector.id
        };
      }
    };

    let situacionSelectConfig = {
      options: [
        {
          text: 'ACTIVA',
          value: 'ACTIVA'
        },
        {
          text: 'SUSPENDIDA',
          value: 'SUSPENDIDA'
        },
        {
          text: 'CANCELADA',
          value: 'CANCELADA'
        },
        {
          text: 'CON RETIRO',
          value: 'CON RETIRO'
        },
        {
          text: 'EN FORMACION',
          value: 'EN FORMACION'
        }
      ]
    };

    return (
      <div>
        <ATable
          pageRange={PAGE_RANGE}
          headers={{
            'Nombre / CUIT': ['nombre', 'cuit'],
            'Matricula': ['matriculaNacional', 'matriculaProvincial'],
            'Domicilio': ['domicilioPostal', 'codigoPostal'],
            'Fundacion / Cierre': ['fechaFundacion', 'cierreEjercicio']
          }}
          service={this.CooperativaService}
          form={{
            fields: [
              ['!Nombre', 'nombre', 'input', 16],
              ['CUIT', 'cuit', 'input', 6],
              ['Matricula Nacional', 'matriculaNacional', 'input', 5],
              ['Matricula Provincial', 'matriculaProvincial', 'input', 5],
              ['Nro Carpeta', 'nroCarpeta', 'input', 8],
              ['Protocolo', 'protocolo', 'input', 8],
              ['Domicilio', 'domicilioPostal', 'input', 8],
              ['Codigo Postal', 'codigoPostal', 'input', 8],
              ['Telefono', 'telefono', 'input', 5],
              ['Email', 'email', 'input', 6],
              ['Contacto', 'contacto', 'input', 5],
              ['Fundacion', 'fechaFundacion', 'datetime', 8],
              ['Cierre Ejercicio', 'cierreEjercicio', 'input', 8],
              ['Localidad', 'LocalidadId', 'asyncselect', 8, localidadSelectConfig],
              ['Sector', 'SectorId', 'asyncselect', 8, sectorSelectConfig],
              ['Actividad', 'actividad', 'textarea', 16, { rows: 4 }],
              ['Situacion', 'situacion', 'select', 16, situacionSelectConfig],
              ['Observacion', 'observacion', 'textarea', 16, { rows: 3 }]
            ],
            service: this.CooperativaService
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    NominaCooperatviasView.mapStateToProps,
    NominaCooperatviasView.mapDispatchToProps
  )(NominaCooperatviasView)
);



// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/NominaCooperativasView.js